import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import { Modal, Button } from "react-bootstrap";
import StudentSidebar from '../../StudentSidebar/StudentSidebar'
import { getHomeTutorListData, getTimeSlotData } from '../../../../Redux/action/MasterAction';
import { getBrowseTutorDetail, getCategoryOnTuotrIdList, getChildCategoryOnTuotrIdList, getSubCategoryOnTuotrIdList } from '../../../../Redux/action/StudentAction';
import Beatloader from '../../../../Common/BeatLoader';
import moment from "moment-timezone";
import { jwtDecode } from "jwt-decode";
const host = process.env.REACT_APP_API_SERVER
const StudentReqOneToOneTutoring = () => {
    const [showModal, setShowModal] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { b64id } = useParams();
    const [tutorId, setTutorId] = useState(null)
    const authToken = localStorage.getItem('student-token');
    const decoded = jwtDecode(authToken);

    const userTimeZone = decoded?.user?.time_zone
    const todayLocal = moment().tz(userTimeZone).format("YYYY-MM-DD"); // Convert to local timezone
    const [filteredTimeSlots, setFilteredTimeSlots] = useState([]);


    useEffect(() => {
        try {

            const tutorId = atob(b64id);

            if (!tutorId || isNaN(tutorId)) {
                throw new Error("Invalid course ID");
            }
            else {
                setTutorId(tutorId)
            }

            dispatch(getCategoryOnTuotrIdList(tutorId));
            dispatch(getBrowseTutorDetail(tutorId))
        } catch (error) {

            navigate(-1);
        }
    }, [b64id]);



    useEffect(() => {
        dispatch(getHomeTutorListData(''))

        dispatch(getTimeSlotData(authToken))


    }, []);


    const {

        loadingHomeTutorListDataListApi,
        HomeTutorListDataListApiData,
        HomeTutorListDataListApiError,


        loadingTimeSlotDataListApi,
        TimeSlotDataListApiData,
        TimeSlotDataListApiError,

    } = useSelector(state => state?.MasterReducer);

    const {

        loadingCategoryOnTutorListApi,
        CategoryOnTutorListApiData,
        CategoryOnTutorListApiError,

        loadingSubCategoryOnTutorListApi,
        SubCategoryOnTutorListApiData,
        SubCategoryOnTutorListApiError,

        loadingChildCategoryOnTutorListApi,
        ChildCategoryOnTutorListApiData,
        ChildCategoryOnTutorListApiError

    } = useSelector(state => state?.StudentReducer);

    let [initialValues, setInitialValues] = useState({


        teaching_type_id: "0",
        tutor_id: "",
        category_id: "",
        sub_category_id: "",
        child_sub_category_id: "",
        start_date: "",
        time_slot_id: "",
        topic_details: ""

    })
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object().shape({
            tutor_id: Yup.string().required("Tutor is required"),
            category_id: Yup.string().required("Class is required"),
            sub_category_id: Yup.string().required("Subject is required"),
            child_sub_category_id: Yup.string().required("Module is required"),
            start_date: Yup.string().required("Start Date is required"),
            time_slot_id: Yup.string().required("Time slot is required"),
            topic_details: Yup.string().required("Detail of discussion is required"),



        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {

            try {
                values.teaching_type_id = '0'

                setSubmitting(true);
                const authToken = localStorage.getItem('student-token')

                let config = {
                    headers: {
                        "x-auth-token": authToken,
                    },
                };
                axios.post(`${host}/api/student/request-tutor/new-request`, values, config)

                    .then(res => {

                        if (res.status == 200) {

                            toast.success(res.data.message);
                            resetForm()
                            setSubmitting(false);
                            setShowModal(true);
                            setTimeout(() => {
                                setShowModal(false);
                                navigate('/student/browse-tutor');
                            }, 1000);

                        } else {

                            toast.error(res.data.message);
                            setSubmitting(false);
                        }
                    }).catch(err => {
                        console.log(err)
                        if (err.response) {
                            toast.error(err.response.data.message);
                        } else {
                            toast.error("Internal server error.")
                        }
                        setSubmitting(false);
                    });



            }
            catch (error) {

                console.log(error);
                toast.error(error.response.data.message);
                setSubmitting(false);

            }

        }
    });


    useEffect(() => {
        if (!TimeSlotDataListApiData?.data) return;

        const slots = TimeSlotDataListApiData.data.filter((slot) => {
            const start = moment(slot.start_time, "HH:mm:ss");
            const end = moment(slot.end_time, "HH:mm:ss");

            // Hide slots crossing midnight
            return end.isSameOrAfter(start);
        });

        setFilteredTimeSlots(slots);

    }, [TimeSlotDataListApiData]);


    const handleTutorChange = (e) => {
        const id = e.target.value

        dispatch(getCategoryOnTuotrIdList(id))
    }
    const handleClassChange = (e) => {
        const id = e.target.value

        formik.setFieldValue('sub_category_id', '')
        formik.setFieldValue('child_sub_category_id', '')
        if (id == '') {
            dispatch(getSubCategoryOnTuotrIdList('0', formik.values.tutor_id))
        }
        else {
            dispatch(getSubCategoryOnTuotrIdList(id, formik.values.tutor_id))
        }
        dispatch(getChildCategoryOnTuotrIdList('0', '0', formik.values.tutor_id))
    }

    const handleSubjectChange = (e) => {
        const id = e.target.value


        formik.setFieldValue('child_sub_category_id', '')
        if (id == '') {
            dispatch(getChildCategoryOnTuotrIdList('0', '0', formik.values.tutor_id))
        }
        else {
            dispatch(getChildCategoryOnTuotrIdList(formik.values.category_id, id, formik.values.tutor_id))
        }
    }


    useEffect(() => {

        formik.setValues({
            tutor_id: tutorId ?? "",

        });

    }, [tutorId]);

    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;Browse Tutor
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <form onSubmit={formik.handleSubmit} method='post'>
                                <main className="px-3 py-4">
                                    {loadingHomeTutorListDataListApi ?
                                        <Beatloader />
                                        :
                                        <div className="browse-tutor">
                                            <h4 className="mb-4">Browse Tutor</h4>
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6 mb-2">
                                                    <h6>Select Tutor <span className='text-danger'>*</span></h6>
                                                    <select className="input-form" name='tutor_id'
                                                        disabled
                                                        onChange={(e) => {
                                                            formik.handleChange(e);
                                                            handleTutorChange(e)
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.tutor_id}>
                                                        <option value=''>-Select-</option>
                                                        {HomeTutorListDataListApiData?.map((data) => (
                                                            <option value={data?.id}>{data?.name}</option>
                                                        ))}
                                                    </select>
                                                    <div className="help-block with-errors mb-2 mt-0 ">
                                                        {formik.errors.tutor_id ? (
                                                            <div className='text-danger'>{formik.errors.tutor_id}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 mb-2">
                                                    <h6>Select Class/Grade/General<span className='text-danger'>*</span></h6>
                                                    <select className="select-form" name='category_id'
                                                        onChange={(e) => {
                                                            formik.handleChange(e);
                                                            handleClassChange(e)
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.category_id} >
                                                        <option value=''>-Select-</option>
                                                        {CategoryOnTutorListApiData?.map((data) => (
                                                            <option value={data?.id}>{data?.is_other ? data?.other_name : data?.name}</option>
                                                        ))}
                                                    </select>
                                                    <div className="help-block with-errors mb-2 mt-0">
                                                        {formik.errors.category_id ? (
                                                            <div className='text-danger'>{formik.errors.category_id}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 mb-2">
                                                    <h6>Select Subject<span className='text-danger'>*</span></h6>
                                                    <select className="select-form" name='sub_category_id'
                                                        onChange={(e) => {
                                                            formik.handleChange(e);
                                                            handleSubjectChange(e)
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.sub_category_id}>
                                                        <option value=''>-Select-</option>
                                                        {SubCategoryOnTutorListApiData?.map((data) => (
                                                            <option value={data?.id}>{data?.is_other ? data?.other_name : data?.name}</option>
                                                        ))}
                                                    </select>
                                                    <div className="help-block with-errors mb-2 mt-0">
                                                        {formik.errors.sub_category_id ? (
                                                            <div className='text-danger'>{formik.errors.sub_category_id}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 mb-2">
                                                    <h6>Select Module<span className='text-danger'>*</span></h6>
                                                    <select className="select-form" name='child_sub_category_id'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.child_sub_category_id}>
                                                        <option value=''>-Select-</option>
                                                        {ChildCategoryOnTutorListApiData?.map((data) => (
                                                            <option value={data?.id}>{data?.name}</option>
                                                        ))}
                                                    </select>
                                                    <div className="help-block with-errors mb-2 mt-0">
                                                        {formik.errors.child_sub_category_id ? (
                                                            <div className='text-danger'>{formik.errors.child_sub_category_id}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 mb-2">
                                                    <h6>Select Date<span className='text-danger'>*</span></h6>
                                                    <input type="date" className="input-card-form" name='start_date'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.start_date}
                                                        min={todayLocal} />
                                                    <div className="help-block with-errors mb-2 mt-0">
                                                        {formik.errors.start_date ? (
                                                            <div className='text-danger'>{formik.errors.start_date}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 mb-2">
                                                    <h6>Select Your Local Time Slot ({TimeSlotDataListApiData?.timeZoneAbb}) <span className='text-danger'>*</span></h6>
                                                    <select className="select-form" name='time_slot_id'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.time_slot_id}>
                                                        <option value=''>-Select-</option>
                                                        {/* {TimeSlotDataListApiData?.data?.map((data) => (
                                                            <option value={data?.id}>{data?.formated_start_time} - {data?.formated_end_time}</option>
                                                        ))} */}
                                                        {filteredTimeSlots.map((data) => (
                                                            <option key={data.id} value={data.id}>
                                                                {data.formated_start_time} - {data.formated_end_time}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <div className="help-block with-errors mb-2 mt-0">
                                                        {formik.errors.time_slot_id ? (
                                                            <div className='text-danger'>{formik.errors.time_slot_id}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 col-md-12">
                                                    <h6>Enter the Details of Discussions<span className='text-danger'>*</span></h6>
                                                    <textarea
                                                        className="select-form" name='topic_details'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.topic_details}
                                                        placeholder="Enter the Details of Discussions"

                                                        defaultValue={""}
                                                    />
                                                    <div className="help-block with-errors mb-2 mt-0">
                                                        {formik.errors.topic_details ? (
                                                            <div className='text-danger'>{formik.errors.topic_details}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    <button
                                                        type='submit'
                                                        className="btn btn-primary w-100"
                                                    // data-bs-toggle="modal"
                                                    // data-bs-target="#thanksModal"
                                                    >
                                                        Submit Request
                                                    </button>
                                                </div>
                                            </div>
                                        </div>}
                                </main>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Thank you Modal */}
                <Modal className='modal' show={showModal} onHide={() => setShowModal(false)}>

                    <Modal.Body>
                        <div
                            className="modal-body my-4"
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <img src="/assets/img/user/okay-img.png" className="img-fluid" />
                            <h4>Thank You!</h4>
                            <p className="text-center">
                                Your request for preferred tutor has been received. We will notify
                                you shortly tutors available according to your requirements.
                            </p>
                            <Link to="/student/dashboard">
                                <button

                                    type="button"
                                    className="btn btn-primary px-5"
                                    data-bs-dismiss="modal"
                                >
                                    Done
                                </button>
                            </Link>
                        </div>
                    </Modal.Body>

                </Modal>
            </>


        </div>
    )
}

export default StudentReqOneToOneTutoring